import React from "react";
import { useNavigate } from "react-router-dom";
import "./MobileFooter.css"
import logo from '../assets/tykven_web.png';
import { 
  MdHome, 
  MdPerson 
} from "react-icons/md";
import { GrTask } from "react-icons/gr";

const MobileFooterNav = () => {
  const navigate = useNavigate();

  const navItems = [
    { icon: MdHome, route: "/dashboard" },
    { icon: GrTask, route: "/tasklist" },
    { icon: MdPerson, route: "/profile" },
  ];

  return (
    <>
    <footer className="bottom-nav">
      {navItems.map((item, idx) => {
        const IconComponent = item.icon;
        return (
          <button 
            key={idx} 
            className="bottom-nav__btn"
            onClick={() => navigate(item.route)}
          >
            <IconComponent className="bottom-nav__icon" size={20} />
          </button>
        );
      })}
    </footer>

    <section>
<div className="bottom-footer">
        <div className="bottom-footer-logo" >
        <img src={logo} width="50px"/>
      </div>
</div>
    </section>
  </>
  );
};

export default MobileFooterNav;